import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../style/onboarding2.css"; // reuse the same base styles
import logo from '../assets/clikkle-creator.png';

export default function HomeLanding() {
  const navigate = useNavigate();
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    const prev = document.body.style.backgroundColor;
    document.body.style.backgroundColor = "#ffffff";
    return () => { document.body.style.backgroundColor = prev; };
  }, []);

  async function handleGenerate() {
    setErr("");
    const clean = url.trim();
    if (!clean) {
      setErr("Please enter a website address.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.get("http://localhost:6955/api/brand/scrape", {
        params: { url: clean },
      });
      localStorage.setItem("onboarding.brand", JSON.stringify(data));
      navigate("/onboarding/step-2", { state: { from: "website", ...data } });
    } catch (e) {
      console.error(e);
      // still send them to step-2 to edit details manually
      navigate("/onboarding/step-2", {
        state: {
          from: "website",
          sourceUrl: clean,
          businessName: "",
          description: "",
          favicon: "",
          brandColors: ["#0066FF", "#000000", "#FFFFFF"],
        },
      });
    } finally {
      setLoading(false);
    }
  }

  function onKeyDown(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      handleGenerate();
    }
  }

  return (
    <div className="home-wrap">
      {/* Simple top header */}
      <header className="home-header">
        <div className="home-header-inner">
          <div className="home-logo">
            <img src={logo} alt="Clikkle Logo" className="h-12" />
          </div>
          <nav className="home-nav">
            <a href="/login" className="home-link">Login</a>
            <a href="/register" className="home-cta">Try for free</a>
          </nav>
        </div>
      </header>

      {/* Hero */}
      <section className="home-hero">
        <h1 className="home-title">
          AI-Powered Content Creation
        </h1>
        <p className="home-subtitle">
          Generate, schedule, and publish professional content across platforms.<br />
          Enter your website, product, listing, or any idea to create content now.
        </p>

        {/* Big input + button */}
        <div className="home-inputbar">
          <input
            className="home-input"
            placeholder="Enter your website address"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            onKeyDown={onKeyDown}
          />
          <button
            className="home-button"
            onClick={handleGenerate}
            disabled={loading}
          >
            {loading ? "Fetching…" : "Generate Content"}
          </button>
        </div>

        <div className="home-aux">
          <button
            type="button"
            className="home-textlink"
            onClick={() =>
              navigate("/onboarding/step-2", {
                state: {
                  from: "no-website",
                  businessName: "",
                  description: "",
                  favicon: "",
                  brandColors: ["#0066FF", "#000000", "#FFFFFF"],
                },
              })
            }
          >
            I have a business without a website
          </button>
        </div>

        {err && <div className="home-error">{err}</div>}
      </section>

    </div>
  );
}
